<template>
    <div class="k-dropdown" :class="{ 'k-dropdown--caret': caret }">
        <div @click="toggleOpen">
            <slot name="button"></slot>

            <span class="k-dropdown__caret" v-if="caret">
                <svg width="12" height="6" xmlns="http://www.w3.org/2000/svg" id="chevron-down" viewBox="0 0 12.17 6.465">
                    <path d="M.136.78l5.628 5.554a.457.457 0 0 0 .641 0L12.034.781a.456.456 0 1 0-.641-.649L6.085 5.365.777.131A.456.456 0 1 0 .136.78z" />
                </svg>
            </span>
        </div>

        <transition name="fade">
            <div v-if="isOpen" class="k-dropdown__menu" :class="{ 'k-dropdown__menu--right': position == 'right', 'k-dropdown__menu--left': position == 'left', 'k-dropdown__menu--overlay': position == 'overlay' }">
                <slot name="dropdown">
                </slot>
            </div>
        </transition>
    </div>

</template>


<script>
export default {

    props: {
        position: {
            type: String,
            default: 'left'
        },
        caret: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isOpen: false
        }
    },


    methods: {
        toggleOpen() {
            this.isOpen = !this.isOpen;
            this.$root.$emit('headerDropdownOpened', this);
        }
    },

    mounted() {
        this.$root.$on('headerDropdownOpened', element => {
            if (element != this) {
                this.isOpen = false;
            }
        });

        this.$root.$on('closeAllDropdowns', event => {
            if (!this.$el.contains(event.target)) {
                this.isOpen = false;
            }
        });
    }

}
</script>

<style lang="scss">
.k-dropdown {
    position: relative;
    height: 100%;
    display: flex;
}

.k-dropdown__menu {
    position: absolute;
    top: 100%;
    min-width: 100%;
}

.k-dropdown__menu--right {
    right: 0;
}



.k-dropdown--caret .k-menu__link {
    padding-right: 40px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.k-dropdown__caret {
    position: absolute;
    top: calc(50% - 8px);
    right: 20px;
    height: 16px;
    display: block;
}

.k-dropdown__menu--overlay {
    min-width: 500px;
    right: 1px; // because border
    top: 0;
    bottom: 0;
}
</style>
